<template>
  <div
    class="bg-static-info-low rounded-sm body-2 mt-12 flex items-center gap-8 px-12 py-8"
  >
    <span class="heading-2">+</span>

    <slot />
  </div>
</template>
